<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-8 w-16 shrink-0 mx-auto">
    <path
        d="M2 16C2 13.7909 3.79086 12 6 12H24L28 16H58C60.2091 16 62 17.7909 62 20V52C62 54.2091 60.2091 56 58 56H6C3.79086 56 2 54.2091 2 52V16Z"
        fill="var(--secondary-color)" />
    <path d="M58 16H28L24 12H6C3.79086 12 2 13.7909 2 16V20H62V20C62 17.7909 60.2091 16 58 16Z"
          fill="var(--primary-color)" fill-opacity="0.5" />
    <path d="M2 20H62V52C62 54.2091 60.2091 56 58 56H6C3.79086 56 2 54.2091 2 52V20Z" fill="var(--primary-color)" />
</svg>
